module.exports = __webpack_public_path__ + "static/mascot-cta-37b7a779355242e6d5c6df339f9787bd.png";